import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('tr-TR', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const getStatusColor = (status) => {
  switch (status?.toUpperCase()) {
    case 'ACTIVE':
      return 'status-badge-active';
    case 'PENDING':
      return 'status-badge-pending';
    case 'REJECTED':
      return 'status-badge-rejected';
    default:
      return 'bg-slate-100 text-slate-600';
  }
};

export const getRoleLabel = (role) => {
  switch (role) {
    case 'SUPER_ADMIN':
      return 'Super Admin';
    case 'FULL_ADMIN':
      return 'Full Admin';
    case 'FIRM_ADMIN':
      return 'Firma Admin';
    case 'EMPLOYEE':
      return 'Çalışan';
    default:
      return role;
  }
};
